<template>
  <div
    class="kv-list d-flex flex-column"
    :class="isLongList ? 'long-list' : 'short-list'"
  >
    <div :class="`list-area ${listStyle}`">
      <div class="item d-flex" v-for="(item, index) in items" :key="index">
        <div class="key" v-if="item.keyGlobal">{{ $t(item.keyGlobal) }}</div>
        <div class="key" v-else>{{ item.key }}</div>

        <div class="value" v-if="item.type == undefined">
          {{ getValue(item) }}
        </div>

        <PasswordLabel
          v-else-if="item.type == 'password'"
          :value="getValue(item)"
          class="value"
        />

        <CopyButtonLabel
          v-else-if="item.type == 'copy'"
          :value="getValue(item)"
          class="value"
        />

        <ShowMoreLabel
          v-else-if="item.type == 'showMore'"
          :value="getValue(item)"
          class="value"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyValueList',
  props: {
    items: {
      type: Array,
      default: [],
    },
    isLongList: {
      type: Boolean,
      default: false,
    },
    listStyle: {
      type: String,
      default: 'dark',
    },
  },
  methods: {
    getValue(item) {
      if (item.valueGlobal) return this.$t(item.valueGlobal)
      else if (item.value && item.value != '') return item.value
      else return this.$t('global.unknown')
    },
  },
}
</script>

<style lang="scss" scoped>
.kv-list {
  min-width: 300px;
  height: 100%;
  padding: 10px 20px;
  &.short-list {
    width: 400px;
    border-right: 1px solid #eeeff3;
    justify-content: center;
    .item {
      width: 100%;
      .key {
        width: 40%;
      }
      .value {
        width: 50%;
      }
    }
  }
  &.long-list {
    .item {
      display: grid !important;
      grid-template-columns: 2fr 3fr;
    }
  }

  .list-area {
    padding: 20px;
    border-radius: 12px;
    position: relative;
    &.dark {
      background: #0a1f44;
      .item {
        .value {
          color: #ffffff;
        }
      }
    }
    &.light {
      background: #ffffff;
      .item {
        .value {
          color: #0a1f44;
        }
      }
    }
    .item {
      margin-bottom: 10px;
      // width: 100%;
      &:last-child {
        margin-bottom: 0px;
      }
      .key {
        // width: 50%;
        padding-right: 15px;
        text-align: right;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #8b959c;
      }
      .value {
        // width: 50%;
        padding-left: 15px;
        text-align: left;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        & i {
          font-size: 12px;
          line-height: 18px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
